<template>
	<div v-if="this.customer">
		<menu-desktop :menuSelected="this.menuSelected" :customer="this.customer" />

		<menu-mobile v-if="this.user" :user="this.user" :menuSelected="this.menuSelected" :customer="this.customer" />
		<div class="container-right">
			<div class="barTop" :class="menuSelected.newOrder ? 'view' : 'bar-top-white'">
				<div class="logo-mobile" v-if="menuSelected.newOrder">
					<img src="@/assets/images/logo.jpg" />
				</div>
				<div class="menu-white" v-if="menuSelected.newOrder" @click="openMenu(true)">
					<img src="@/assets/images/menu-burger-alb.svg" />
				</div>

				<div class="mobile-nav">
					<div class="arrow-back" @click="goBack()">
						<img src="@/assets/images/arrow-back.svg" />
					</div>
					<div class="page-title">
						<h3>{{ "New Order" }}</h3>
					</div>
					<div class="menu-white" @click="openMenu(true)">
						<img src="@/assets/images/menu-burger-gri.svg" />
					</div>
				</div>
				<TopBar v-if="this.user" :user="this.user" />
			</div>

			<div class="content">
				<NewOrder :customer="this.customer" :userRole="this.selectedCompany.role" :user="this.user" />
			</div>
		</div>
	</div>
</template>

<style scoped src="@/assets/styles/beneficiary.css"></style>

<script>

import MenuDesktop from "@/components/company/customer/MenuDesktop.vue";
import MenuMobile from "@/components/company/customer/MenuMobile.vue";
import TopBar from "@/components/company/TopBar.vue";
import NewOrder from "@/components/company/customer/NewOrder.vue";

export default {
	components: {
		MenuDesktop,
		MenuMobile,
		NewOrder,
		TopBar,
	},
	data() {
		return {
			user: null,
			customer: null,
			selectedCompany: null,
			menuSelected: {
				newOrder: true,
			},
		};
	},
	created() {
		// console.log (this.$route.params);
		this.showModalPopup("modal_popup_loading", true);

		if (this.user == null) {
			this.user = this.getUserData();
		} else {
			this.showModalPopup("modal_popup_loading", false);

		}
		if (this.selectedCompany == null) {
			this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
		}
		this.customer = this.getCustomerData('new c', this.selectedCompany.role)
	},
	computed: {
		dataLoaded() {
			return this.$store.state.customerDataLoaded;
		},
	},
	watch: {
		'$store.state.customerDataLoaded': {
			handler() {
				if (this.customer == null || this.user == null){
				// update locally relevant data
					this.user = this.getUserData();
					this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
					this.customer = this.getCustomerData('new w', this.selectedCompany.role);
					this.showModalPopup("modal_popup_loading", false);
				}
			}
		}
	}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
